import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled, { keyframes } from 'styled-components'
import AnimationContainer from 'components/animation-container'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowLeft, faArrowRight,   
} from '@fortawesome/free-solid-svg-icons'
import { Link } from 'gatsby'


class Bcloud extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #f6f6f6;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            flex-wrap: wrap;
            margin-right: -15px;
            margin-left: -15px;
            display: flex;
        `

        const ServiceHeading = styled.h3`
            font-size: 18px;
            font-weight: 700;
            color: #212122;
            @media (max-width: 767px) {
              font-size: 16px;
          }
        `

        const Heading = styled.h2`
            font-size: 24px;
            font-weight: 700;
            color: #212122;
            text-align:center;
        `

        const ServiceHeadinga = styled(Link)`
            color: #000;         
            &:before {
              content: '';
              position: absolute;
              top: 35px;
              bottom: 0;
              left: 28%;
              width: 1px;
              height: 50%;
              background: #ebebeb;
              transition: all .3s ease;
            }
            &:hover {
              color: #65ff00;              
            }
        `
         
        const ServiceText = styled.p`
          font-size: 16px;
          line-height: 26px;
          color: #808080;
          margin-top: 5px;
          font-family: 'Open Sans',sans-serif;
          font-weight: normal;
          @media (max-width: 767px) {
            font-size: 14px;
            line-height: 20px;
          }
        `

        const Inform = styled.div`
            width: 72%;
            padding: 10px 30px;
            display: inline-block;
            vertical-align: middle;
        `

        const ServiceWrap = styled.div`            
            font-weight: bold;
            color: #ff6d37;            
        `

        const AnimatedShadow = keyframes`
            0%   {box-shadow: 0 2px 60px rgba(126, 126, 126, .5);}
            10%  {box-shadow: 0 4px 60px rgba(80,115,184, .5);}
            20%  {box-shadow: 0 6px 60px rgba(80,115,184, .5);}
            30%  {box-shadow: 0 10px 60px rgba(126, 126, 126, .5);}
            40% {box-shadow: 0 14px 60px rgba(80, 115, 184, .5);}
            50% {box-shadow: 0 16px 60px rgba(126, 126, 126, .5);}
            60% {box-shadow: 0 18px 60px rgba(62, 62, 62, .5);}
            70% {box-shadow: 0 22px 60px rgba(62, 62, 62, .5);}
            80% {box-shadow: 0 24px 60px rgba(80, 115, 184, .5);}
            90% {box-shadow: 0 26px 60px rgba(16, 152, 173, .5);}
            100% {box-shadow: 0 28px 60px rgba(126, 126, 126, .5);}
            -webkit-transition: all 300ms linear 0ms;
	          -moz-transition: all 300ms linear 0ms;
	          -ms-transition: all 300ms linear 0ms;
	          transition: all 300ms linear 0ms;
            transition: all .3s ease;
        `

        const HelpContainer = styled.div`            
            position: relative;
            height: 145px;
            margin-top: 50px;
            border-radius: 3px;
            background-color: #fff;
            box-shadow: 0 5px 15px 0 rgba(110, 110, 110, .1);
            transition: all .3s ease;
            &:hover {
              background-color: #fff;
              animation: ${AnimatedShadow} 10s infinite alternate;
              transform: translateY(-5px);
              
          }
        `

        const Img = styled.div`            
            display: inline-block;
            vertical-align: middle;
            position: relative;
            width: 28%;
            height: 100%;
        `

        const Ico = styled.svg`            
            position: absolute;
            top: 30%;
            left: 30%
        `

        const BadgeGrey = styled.div`
            position: absolute;
            right: auto;
            left: 10px !important;
            display: inline-block;
            padding: .25em .4em;
            background-color: #808080 !important;
            color: #ffffff !important;
            top: 10px;
            z-index: 1;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .10rem;
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        `

        const BadgeGreyR = styled.div`
            position: absolute;
            right: 10px;            
            display: inline-block;
            padding: .25em .4em;
            background-color: #808080 !important;
            color: #ffffff !important;
            top: 10px;
            z-index: 1;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .10rem;
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        `

        return(
          <Section>
            <Container>
              <Col md={12}>
                <Heading>
                  ¿Necesitas mas prestaciones, servicios más robustos o recursos propios?
                </Heading>
              </Col>
              <ServiceWrap>
                <ServiceRow>
                  <Col md={6}>
                    <AnimationContainer animation="fadeInDown" delay={200}>
                      <HelpContainer>
                        <BadgeGrey><FontAwesomeIcon icon={faArrowLeft} size="1x" /></BadgeGrey>                        
                          <Img>
                            <Ico>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 32 32">
                              <title>vps</title>
                              <path fill="#5e686c" d="M29.55 13.35h-16.175c-0.231 0-0.419 0.188-0.419 0.419s0.188 0.419 0.419 0.419h16.175c0.65 0 1.181 0.456 1.181 1.025v8.050c0 0.563-0.531 1.025-1.181 1.025h-27.081c-0.65 0-1.181-0.456-1.181-1.025v-8.050c0-0.563 0.531-1.025 1.181-1.025h4.175c0.231 0 0.419-0.188 0.419-0.419s-0.188-0.419-0.419-0.419h-4.175c-1.113 0-2.025 0.838-2.025 1.863v8.050c0 1.025 0.906 1.863 2.025 1.863h27.081c1.113 0 2.019-0.837 2.019-1.863v-8.050c0.006-1.025-0.906-1.863-2.019-1.863z"></path>
                              <path fill="#5e686c" d="M29.55 0.269h-16.175c-0.231 0-0.419 0.188-0.419 0.419s0.188 0.419 0.419 0.419h16.175c0.65 0 1.181 0.456 1.181 1.025v8.050c0 0.563-0.531 1.025-1.181 1.025h-27.081c-0.65 0-1.181-0.456-1.181-1.025v-8.050c0-0.563 0.531-1.025 1.181-1.025h4.175c0.231 0 0.419-0.188 0.419-0.419s-0.188-0.419-0.419-0.419h-4.175c-1.113 0-2.019 0.831-2.019 1.862v8.050c0 1.025 0.906 1.863 2.025 1.863h27.081c1.113 0 2.019-0.838 2.019-1.863v-8.050c0-1.025-0.913-1.863-2.025-1.863z"></path>
                              <path id="svg-ico" fill="#abd363" d="M25.775 19.663c0.231 0 0.419-0.188 0.419-0.419s-0.188-0.419-0.419-0.419h-2.169c-0.231 0-0.419 0.188-0.419 0.419s0.188 0.419 0.419 0.419h2.169z"></path>
                              <path id="svg-ico" fill="#abd363" d="M25.775 6.575c0.231 0 0.419-0.188 0.419-0.419s-0.188-0.419-0.419-0.419h-2.169c-0.231 0-0.419 0.188-0.419 0.419s0.188 0.419 0.419 0.419h2.169z"></path>
                              <path fill="#5e686c" d="M25.994 29.613h-8.356c-0.15-0.594-0.619-1.056-1.206-1.212v-1.875c0-0.231-0.188-0.419-0.419-0.419s-0.419 0.188-0.419 0.419v1.875c-0.588 0.15-1.056 0.619-1.206 1.212h-8.363c-0.231 0-0.419 0.188-0.419 0.419s0.188 0.419 0.419 0.419h8.356c0.188 0.725 0.85 1.262 1.631 1.262s1.444-0.538 1.631-1.262h8.356c0.231 0 0.419-0.188 0.419-0.419-0.006-0.231-0.194-0.419-0.425-0.419zM16.012 30.875c-0.463 0-0.844-0.375-0.844-0.844 0-0.462 0.375-0.844 0.844-0.844 0.462 0 0.844 0.375 0.844 0.844-0.006 0.462-0.381 0.844-0.844 0.844z"></path>
                            </svg>
                            </Ico>
                          </Img>
                          <Inform>
                            <ServiceHeading>
                            <ServiceHeadinga to="/vps">
                              Ver Servidores VPS
                            </ServiceHeadinga>
                            </ServiceHeading>
                            <ServiceText>Servidor Privado Virtual o VPS. Tu propio servidor a un bajo precio</ServiceText>
                          </Inform>                        
                      </HelpContainer>
                    </AnimationContainer>
                  </Col>
                  <Col md={6}>
                    <AnimationContainer animation="fadeInDown" delay={200}>
                      <HelpContainer>
                        <BadgeGreyR><FontAwesomeIcon icon={faArrowRight} size="1x" /></BadgeGreyR>
                        
                          <Img>
                            <Ico>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 32 32">
                              <title>rack</title>
                              <path id="svg-ico" fill="#abd363" d="M18.95 22.837c-0.869 0-1.581 0.706-1.581 1.581s0.712 1.581 1.581 1.581c0.869 0 1.581-0.712 1.581-1.581 0-0.875-0.712-1.581-1.581-1.581zM18.95 25.206c-0.438 0-0.788-0.356-0.788-0.794s0.356-0.788 0.788-0.788c0.438 0 0.788 0.356 0.788 0.788 0 0.438-0.35 0.794-0.788 0.794z"></path>
                              <path fill="#5e686b" d="M24.1 22.837c-0.869 0-1.581 0.706-1.581 1.581s0.712 1.581 1.581 1.581c0.869 0 1.581-0.712 1.581-1.581 0-0.875-0.706-1.581-1.581-1.581zM24.1 25.206c-0.438 0-0.788-0.356-0.788-0.794s0.356-0.788 0.788-0.788 0.788 0.356 0.788 0.788c0.006 0.438-0.35 0.794-0.788 0.794z"></path>
                              <path fill="#5e686b" d="M20.531 14.781c0-0.869-0.712-1.581-1.581-1.581s-1.581 0.706-1.581 1.581c0 0.875 0.712 1.581 1.581 1.581s1.581-0.706 1.581-1.581zM18.156 14.781c0-0.438 0.356-0.787 0.788-0.787 0.438 0 0.788 0.356 0.788 0.787 0 0.438-0.356 0.794-0.788 0.794s-0.788-0.356-0.788-0.794z"></path>
                              <path id="svg-ico" fill="#abd363" d="M25.681 14.781c0-0.869-0.712-1.581-1.581-1.581s-1.581 0.706-1.581 1.581c0 0.875 0.712 1.581 1.581 1.581 0.875 0 1.581-0.706 1.581-1.581zM23.313 14.781c0-0.438 0.356-0.787 0.788-0.787s0.788 0.356 0.788 0.787c0 0.438-0.356 0.794-0.788 0.794-0.438 0-0.788-0.356-0.788-0.794z"></path>
                              <path fill="#5e686b" d="M18.95 6.731c0.869 0 1.581-0.713 1.581-1.581s-0.712-1.581-1.581-1.581c-0.869 0-1.581 0.706-1.581 1.581s0.706 1.581 1.581 1.581zM18.95 4.362c0.438 0 0.788 0.356 0.788 0.787 0 0.438-0.356 0.794-0.788 0.794-0.438 0-0.788-0.356-0.788-0.794-0.006-0.431 0.35-0.787 0.788-0.787z"></path>
                              <path id="svg-ico" fill="#abd363" d="M24.1 6.731c0.869 0 1.581-0.713 1.581-1.581s-0.712-1.581-1.581-1.581c-0.869 0-1.581 0.706-1.581 1.581s0.712 1.581 1.581 1.581zM24.1 4.362c0.438 0 0.788 0.356 0.788 0.787 0 0.438-0.356 0.794-0.788 0.794-0.438 0-0.788-0.356-0.788-0.794 0-0.431 0.35-0.787 0.788-0.787z"></path>
                              <path fill="#5e686b" d="M27.731 0.181h-23.462c-0.981 0-1.781 0.738-1.781 1.644v25.919c0 0.906 0.8 1.644 1.781 1.644h2.169v1.975c0 0.219 0.175 0.394 0.394 0.394h3.95c0.219 0 0.394-0.175 0.394-0.394v-1.975h9.637v1.975c0 0.219 0.175 0.394 0.394 0.394h3.95c0.219 0 0.394-0.175 0.394-0.394v-1.975h2.169c0.981 0 1.781-0.738 1.781-1.644v-25.919c0.012-0.906-0.788-1.644-1.769-1.644zM10.394 30.969h-3.162v-1.581h3.162v1.581zM24.769 30.969h-3.163v-1.581h3.163v1.581zM28.719 27.744c0 0.469-0.444 0.856-0.994 0.856h-23.456c-0.55 0-0.994-0.381-0.994-0.856v-25.919c0-0.469 0.444-0.856 0.994-0.856h23.456c0.544 0 0.994 0.381 0.994 0.856v25.919z"></path>
                              <path fill="#5e686b" d="M25.881 9.775h-19.762c-0.219 0-0.394 0.175-0.394 0.394s0.175 0.394 0.394 0.394h19.762c0.219 0 0.394-0.175 0.394-0.394s-0.175-0.394-0.394-0.394z"></path>
                              <path fill="#5e686b" d="M25.881 19h-19.762c-0.219 0-0.394 0.175-0.394 0.394s0.175 0.394 0.394 0.394h19.762c0.219 0 0.394-0.175 0.394-0.394s-0.175-0.394-0.394-0.394z"></path>
                            </svg>
                            </Ico>
                          </Img>
                          <Inform>
                            <ServiceHeading>
                            <ServiceHeadinga to="/servidores-dedicados">
                              Ver Servidores Dedicados
                            </ServiceHeadinga>
                            </ServiceHeading>
                            <ServiceText>Servidor Dedicado. Tu propio servidor para lo que quieras</ServiceText>
                          </Inform>                        
                      </HelpContainer>
                    </AnimationContainer>
                  </Col>
                </ServiceRow>
              </ServiceWrap>
            </Container>
          </Section>
        )
    }

}

export default Bcloud;